'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



//////////////////
// WEBPACK FOOTER
// ./~/call-bind/~/function-bind/index.js
// module id = 658
// module chunks = 0